<template>
  <div class="edit-video-box">
    <el-dialog title="根据手机号码查看或生成验证码" :visible.sync="dialogVisible" style="max-width:700px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100">
        <el-form-item label="请输入手机号码:" prop="mobile">
          <el-input v-model="form.mobile" autocomplete="off" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import { validatorMobile } from "@/utils/validator";
export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        mobile: ""
      },
      rules: {
        mobile: [
          {
            required: true,
            message: "请输入正确格式的手机号码",
            trigger: "blur"
          },
          { validator: validatorMobile, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    // 根据手机号查看或生成验证码
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.getViewCaptcha();
        } else {
          window.console.log("error submit!!");
          return false;
        }
      });
    },
    getViewCaptcha() {
      this.loading = true;
      let form = Object.assign({}, this.form, { mobile: this.form.mobile });
      API.getViewCaptcha(form)
        .then(res => {
          if (res.code === 200 && res.data) {
            this.dialogVisible = false;
            let captcha = res.data.captcha;
            return captcha;
          }
        })
        .then(captcha => {
          this.$message({
            type: "success",
            message: "你的验证码是: " + captcha
          });
        });
    },
    // 外层弹窗关闭
    handleClose() {
      this.dialogVisible = false;
    },
    open() {
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-input {
    width: 150px;
  }
}
.form_item {
  display: flex;
}
</style>
